import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from "rxjs";
import { getCurrencySubTypeItem } from 'src/app/core/helpers/common-functions';
import { CustomerDebtReceivableListModel } from 'src/app/models/account-transaction/customer-debt-receivable-list-model';
import { Branch } from 'src/app/models/branch/branch';
import { CustomerBalanceDTO } from 'src/app/models/customer/customerBalanceDTO';
import { AllCurrencyList, Currency } from 'src/app/models/enums/currency';
import { CurrencySubTypes } from 'src/app/models/enums/currency-sub-types';
import { WidgetService } from 'src/app/services/widget.service';
import { FastCollectionModalComponent } from '../../collections/fast-collection-modal/fast-collection-modal.component';

@Component({
  selector: 'app-customer-balance-report',
  templateUrl: './customer-balance-report.component.html',
  styleUrls: ['./customer-balance-report.component.scss']
})
export class CustomerBalanceReportComponent implements OnInit, OnDestroy {

  refreshSubs = new Subscription();
  receivableListSubs = new Subscription();
  branch: Branch = JSON.parse(localStorage.getItem("currentBranch"));
  customerListWithDebt: CustomerBalanceDTO[] = [];
  filterableList: CustomerBalanceDTO[] = [];
  showedList: CustomerDebtReceivableListModel[] = [];
  currencyList: Currency[] = [
    Currency.Tl,
    Currency.Usd,
    Currency.Euro,
    Currency.Gold,
    Currency.Accessories,
    Currency.Silver,
    Currency.OtherAccessories,
    Currency.Other
  ];
  subTypeList: CurrencySubTypes[] = null;
  defaultValue = null;
  filter = { customerName: null, currency: null, subType: null };

  constructor(
    private widgetService: WidgetService,
    private modalService: NgbModal
  ) {}
  ngOnDestroy(): void {
    this.refreshSubs.unsubscribe();
    this.receivableListSubs.unsubscribe();
  }

  ngOnInit(): void {
    //this.currencyList = AllCurrencyList;
    this.reloadData();
    this.refreshSubs =
      this.widgetService.refreshCustomerDebtReceivableWidget.subscribe(
        (res) => {
          this.reloadData();
        }
      );
  }
  reloadData() {
    this.widgetService
      .getCustomerBalanceReport()
      .toPromise()
      .then((res) => {
        this.customerListWithDebt = res.data;
        this.filterableList = JSON.parse(
          JSON.stringify(this.customerListWithDebt)
        );
        this.showedList = this.prepareShowedList(this.filterableList);
      });
  }
prepareShowedList(list: CustomerBalanceDTO[]) {
    let newList: CustomerDebtReceivableListModel[] = [];
    list.map((p) => {
      let item = newList.find((x) => x.customerId == p.id);
      if (item == null) {
        let newItem = new CustomerDebtReceivableListModel();
        newItem.customerId = p.id;
        newItem.customerName = p.name;
        newItem.customerBalances = [
          {
            balance: p.balance,
            currency: p.currency,
            subType: p.subType,
            id: p.id,
            name: p.name,
          },
        ];
        newList.push(newItem);
      } else {
        item.customerBalances.push({
          balance: p.balance,
          currency: p.currency,
          subType: p.subType,
          id: p.id,
          name: p.name,
        });
      }
    });
    return newList;
  }
  
  
  setSubTypes() {
      let item = getCurrencySubTypeItem(this.filter.currency);
      //this.filter.currency = item.currency;
      this.subTypeList = item.subtypes;
      this.filterToList();
  }
  filterToList() {
    let list = JSON.parse(JSON.stringify(this.customerListWithDebt));

    if (this.filter.customerName != null) {
      list = this.getByNameFromList(list, this.filter);
    }

    if (this.filter.currency != null) {
      list = this.getByCurrencyFromList(list, this.filter);
    }

    if (this.filter.subType != undefined) {
      list = this.getBySubTypeFromList(list, this.filter);
    }

    this.filterableList = list;
    this.showedList = this.prepareShowedList(this.filterableList);
  }
  getByNameFromList(list: CustomerBalanceDTO[], filter): CustomerBalanceDTO[] {
    return list.filter((customer) =>
      customer.name
        .toLocaleLowerCase()
        .match(filter.customerName.toLocaleLowerCase())
    );
  }

  getByCurrencyFromList(
    list: CustomerBalanceDTO[],
    filter
  ): CustomerBalanceDTO[] {
    return list.filter((customer) => customer.currency == filter.currency);
  }

  getBySubTypeFromList(
    list: CustomerBalanceDTO[],
    filter
  ): CustomerBalanceDTO[] {
    return list.filter((customer) => customer.subType == filter.subType);
  }

  openFastCollectionModal(model: CustomerBalanceDTO, isDebt: boolean) {
    if (isDebt) {
      const modalRef = this.modalService.open(FastCollectionModalComponent);
      modalRef.componentInstance.modalContent = JSON.parse(
        JSON.stringify(model)
      );
      modalRef.componentInstance.isDebtCollection = true;
    } else {
      const modalRef = this.modalService.open(FastCollectionModalComponent);
      modalRef.componentInstance.modalContent = JSON.parse(
        JSON.stringify(model)
      );
      modalRef.componentInstance.isDebtCollection = false;
    }
  }
  goToLink(url: string){
    window.open(url, "_blank");
  }
}
